webpackJsonp([0],{

/***/ "+A6G":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/h3.dd41ef3.jpg";

/***/ }),

/***/ "+JGl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/doc-muslim.90d23a0.jpg";

/***/ }),

/***/ "+Q9R":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/random.c9b2178.jpg";

/***/ }),

/***/ "+v6S":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/11.3c433f5.jpg";

/***/ }),

/***/ "/2pL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GoogleMap_vue__ = __webpack_require__("fXma");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Data_Locations_js__ = __webpack_require__("8tyy");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      centersArr: __WEBPACK_IMPORTED_MODULE_1__Data_Locations_js__["a" /* centersArr */]
    };
  },

  components: {
    "my-map": __WEBPACK_IMPORTED_MODULE_0__GoogleMap_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "/GUx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/I9Q":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/staff-uphc.b8e79b2.jpg";

/***/ }),

/***/ "/OoD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ti_vue__ = __webpack_require__("Va99");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79ef78a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Ti_vue__ = __webpack_require__("ZL6z");
function injectStyle (ssrContext) {
  __webpack_require__("gzmH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79ef78a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ti_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79ef78a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Ti_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/SD8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/preaching.3ef148a.jpg";

/***/ }),

/***/ "/V33":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/change-1.1c45939.jpg";

/***/ }),

/***/ "/kbf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__("/2pL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_423ec96a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__("zqbm");
function injectStyle (ssrContext) {
  __webpack_require__("F5Z9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-423ec96a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_423ec96a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "08G3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-in.1b8a3ac.jpg";

/***/ }),

/***/ "0axH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0kPo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3.4b6fc31.jpg";

/***/ }),

/***/ "0sOa":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/13.7b1de88.jpg";

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1+ad":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "1/pI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ti-1.5c1f856.jpg";

/***/ }),

/***/ "17lt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lab-technician.e04bc82.jpg";

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "29qX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/17.6a4db75.jpg";

/***/ }),

/***/ "2GjZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fileTitles; });
var fileTitles = [{
  name: 'sign.jpg',
  alt: "Our Sign"
}, {
  name: 'staff-kids.jpg',
  alt: "Our staff with kids"
}, {
  name: 'study.jpg',
  alt: "Kids Study"
}, {
  name: 'award-lady.jpg',
  alt: 'Lady Awarded'
}, {
  name: 'book-kid.jpg',
  alt: 'Kids with books'
}, {
  name: 'food-2.jpg',
  alt: 'Giving out food'
}, {
  name: 'food.jpg',
  alt: 'More food spread'
}, {
  name: 'house.jpg',
  alt: 'Typical house in slums'
}, {
  name: 'kid-dad.jpg',
  alt: 'Parents with kids'
}, {
  name: 'kid-group.jpg',
  alt: 'kids huddled up'
}, {
  name: "kids-books.jpg",
  alt: 'kids with books'
}, {
  name: 'kids-many.jpg',
  alt: 'kids in a group'
}, {
  name: "kids-more.jpg",
  alt: 'more kids in a group'
}, {
  name: 'kids-poor.jpg',
  alt: 'Poor kids'
}, {
  name: 'kids-sit.jpg',
  alt: 'Kids sitting and drawing'
}, {
  name: 'kids.jpg',
  alt: "Kids in Slums"
}, {
  name: 'lady-happy.jpg',
  alt: "Slum lady volunteer"
}, {
  name: 'parents-kids.jpg',
  alt: "Parents and their kids"
}, {
  name: 'partap.jpg',
  alt: "Team member Helping"
}, {
  name: 'partap-2.jpg',
  alt: "Giving out notebooks"
}, {
  name: 'path.jpg',
  alt: "path to the slum"
}, {
  name: 'posing.jpg',
  alt: "awarding a child"
}, {
  name: 'preaching.jpg',
  alt: "Motivating kids"
}, {
  name: 'preaching-2.jpg',
  alt: "Sharing experiences with kids"
}];

/***/ }),

/***/ "2PRq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fileTitles; });
var fileTitles = [{
  name: 'advising.jpg',
  alt: 'Advising patients'
}, {
  name: 'aware.jpg',
  alt: 'Spreading awareness'
}, {
  name: 'certificate.jpg',
  alt: 'Achievement'
}, {
  name: 'cry.jpg',
  alt: 'kid crying'
}, {
  name: 'dad-kid.jpg',
  alt: 'dad-kid combo'
}, {
  name: 'group.jpg',
  alt: 'Group being helped'
}, {
  name: 'happy-doc.jpg',
  alt: 'Happy doctor'
}, {
  name: "hussle.jpg",
  alt: 'busy center'
}, {
  name: 'line.jpg',
  alt: 'Line of patients'
}, {
  name: 'muslim-2.jpg',
  alt: 'Child given dose'
}, {
  name: "old-doc.jpg",
  alt: 'Doctor helping'
}, {
  name: 'patients.jpg',
  alt: 'Waiting Patients'
}, {
  name: 'ranjana.jpg',
  alt: 'Helping kids'
}, {
  name: 'room.jpg',
  alt: "Medical Room"
}, {
  name: 'sign-2.jpg',
  alt: "Sign for center"
}, {
  name: 'team-2.jpg',
  alt: "Our Team"
}, {
  name: 'team.jpg',
  alt: "Team Helping"
}, {
  name: 'tika.jpg',
  alt: "Immunizing"
}];

/***/ }),

/***/ "2Z8I":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/line.f3fe0b3.jpg";

/***/ }),

/***/ "2g6c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('p', {
    staticClass: "h5"
  }, [_vm._v("About")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('router-link', {
    staticClass: "locations-quicklink",
    attrs: {
      "tag": "div",
      "to": {
        path: '/contact#our-centers'
      }
    }
  }, [_vm._v("Our Locations")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/projects'
      }
    }
  }, [_vm._v("Galleries")]), _vm._v(" "), _c('router-link', {
    staticClass: "locations-quicklink",
    attrs: {
      "tag": "div",
      "to": {
        path: '/reports'
      }
    }
  }, [_vm._v("Annual Reports")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_vm._v("\n      © Copyright 2017 | Friends NGO | All Rights Reserved\n    ")])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('p', {
    staticClass: "h5"
  }, [_vm._v("Resources")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.who.int/countries/ind/en/"
    }
  }, [_vm._v("WHO")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.ukhfws.org/index.php "
    }
  }, [_vm._v("UKHFWS")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://naco.gov.in/"
    }
  }, [_vm._v("NACO")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('p', {
    staticClass: "h5 "
  }, [_vm._v("Miscellaneous")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://nhm.gov.in"
    }
  }, [_vm._v("National Health Mission")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.nhp.gov.in/"
    }
  }, [_vm._v("National Health Portal")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3ALm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.d15a16a.jpg";

/***/ }),

/***/ "3Be5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpecialCamps_vue__ = __webpack_require__("4VP/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e889f0f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SpecialCamps_vue__ = __webpack_require__("M8Mp");
function injectStyle (ssrContext) {
  __webpack_require__("/GUx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e889f0f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpecialCamps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e889f0f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SpecialCamps_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3Zj4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3o0v":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/9.d337ad4.jpg";

/***/ }),

/***/ "3qJl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/certificate.e69bebd.jpg";

/***/ }),

/***/ "4VP/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_baguetteBox_js__ = __webpack_require__("/5fg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_baguetteBox_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_baguetteBox_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Camps_data_js__ = __webpack_require__("wfmi");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showGallery: false,
      fileTitles: __WEBPACK_IMPORTED_MODULE_1__Camps_data_js__["a" /* fileTitles */]
    };
  },

  methods: {
    visibleGallery: function visibleGallery() {
      this.showGallery = true;
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_0_baguetteBox_js___default.a.run('.gallery');
      }, 1000);
    },
    hideGallery: function hideGallery() {
      this.showGallery = false;
      window.scrollTo(0, 1500);
    }
  }
});

/***/ }),

/***/ "4Vh3":
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ "4XED":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/girl-power.7386228.jpg";

/***/ }),

/***/ "4ifg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fileTitles; });
var fileTitles = [{
  name: '1.jpg',
  alt: 'Police colleagues'
}, {
  name: "3.jpg",
  alt: 'police academy'
}, {
  name: '12.jpg',
  alt: 'police'
}, {
  name: '13.jpg',
  alt: 'Office'
}, {
  name: '16.jpg',
  alt: 'spreading awareness'
}, {
  name: '18.jpg',
  alt: 'Police'
}, {
  name: 'Ti-1.jpg',
  alt: 'Police'
}, {
  name: 'Ti-2.jpg',
  alt: 'Police'
}, {
  name: "Ti-3.jpg",
  alt: 'Police'
}, {
  name: 'Ti-4.jpg',
  alt: 'AIDS'
}, {
  name: 'Ti-5.jpg',
  alt: 'talking about AIDS'
}, {
  name: "Ti-6.jpg",
  alt: "Local play"
}, {
  name: "Ti-7.jpg",
  alt: "spreading awareness"
}, {
  name: "Ti-8.jpg",
  alt: "locals enjoying the play"
}, {
  name: "Ti-9.jpg",
  alt: "AIDS play"
}, {
  name: "Ti-10.jpg",
  alt: "play about AIDS"
}, {
  name: "Ti-11.jpg",
  alt: "actor performing"
}, {
  name: "Ti-12.jpg",
  alt: "Our staff"
}, {
  name: "Ti-16.jpg",
  alt: "AIDS program"
}, {
  name: "Ti-17.jpg",
  alt: "stage for AIDS program"
}, {
  name: "Ti-19.jpg",
  alt: "Showing safe sex methods"
}];

/***/ }),

/***/ "4rJJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fileTitles; });
var fileTitles = [{
  name: '1.jpg',
  alt: "Our Sign"
}, {
  name: '2.jpg',
  alt: "Our staff with kids"
}, {
  name: '3.jpg',
  alt: "Kids Study"
}, {
  name: '6.jpg',
  alt: 'Giving out food'
}, {
  name: '7.jpg',
  alt: 'More food spread'
}, {
  name: '8.jpg',
  alt: 'Typical house in slums'
}, {
  name: '9.jpg',
  alt: 'Parents with kids'
}, {
  name: '10.jpg',
  alt: 'kids huddled up'
}, {
  name: "11.jpg",
  alt: 'kids with books'
}, {
  name: '12.jpg',
  alt: 'kids in a group'
}, {
  name: "13.jpg",
  alt: 'more kids in a group'
}, {
  name: '14.jpg',
  alt: 'Poor kids'
}, {
  name: '15.jpg',
  alt: 'Kids sitting and drawing'
}, {
  name: '16.jpg',
  alt: "Kids in Slums"
}, {
  name: '17.jpg',
  alt: "Slum lady volunteer"
}, {
  name: '18.jpg',
  alt: "Parents and their kids"
}, {
  name: '19.jpg',
  alt: "Team member Helping"
}, {
  name: '20.jpg',
  alt: "Giving out notebooks"
}];

/***/ }),

/***/ "4uSL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/15.23a8175.jpg";

/***/ }),

/***/ "4zFl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/doc-bp.0c24994.jpg";

/***/ }),

/***/ "52BY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10",
    attrs: {
      "id": "map"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "59bj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_baguetteBox_js__ = __webpack_require__("/5fg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_baguetteBox_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_baguetteBox_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Asha_data_js__ = __webpack_require__("wS09");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showGallery: false,
      fileTitles: __WEBPACK_IMPORTED_MODULE_1__Asha_data_js__["a" /* fileTitles */]
    };
  },

  methods: {
    visibleGallery: function visibleGallery() {
      this.showGallery = true;
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_0_baguetteBox_js___default.a.run('.gallery');
        console.log("baguebox running");
      }, 1000);
    },
    hideGallery: function hideGallery() {
      this.showGallery = false;
      window.scrollTo(0, 1200);
    }
  }
});

/***/ }),

/***/ "5emF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.f1d46fe.jpg";

/***/ }),

/***/ "5iTp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5-out.b5f1f02.jpg";

/***/ }),

/***/ "5k+t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cleaniness_vue__ = __webpack_require__("OdUv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4308edcf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Cleaniness_vue__ = __webpack_require__("cjjS");
function injectStyle (ssrContext) {
  __webpack_require__("Xg8S")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4308edcf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cleaniness_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4308edcf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Cleaniness_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "63Rv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shivir-3.117ce3d.jpg";

/***/ }),

/***/ "68Zu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/team-2.562524e.jpg";

/***/ }),

/***/ "6LVP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/junkies.2858b42.jpg";

/***/ }),

/***/ "6ZSt":
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ "6iiC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/patients.3334107.jpg";

/***/ }),

/***/ "6pC1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/12.8d827de.jpg";

/***/ }),

/***/ "6u/w":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shivir.02c9bd8.jpg";

/***/ }),

/***/ "7roi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.bd97266.jpg";

/***/ }),

/***/ "83qc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/16.b006fde.jpg";

/***/ }),

/***/ "87iU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ti-11.d09a17d.jpg";

/***/ }),

/***/ "889b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/13.28c1024.jpg";

/***/ }),

/***/ "8Jz3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8YCc":
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ "8tyy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return centersArr; });
var centersArr = [{
  locationName: "purani tehsil Roorkee",
  centerName: "Purani Tehsil Center",
  address: "Near Vishwakarma Chowk, Idgah Road, Roorkee"
}, {
  locationName: "mahigran, Roorkee",
  centerName: "Mahigran Center",
  address: "Khazoor Wali Gali, Macchi Market Road, Roorkee"
}, {
  locationName: "salempur, Roorkee",
  centerName: "Salempur (Ram Nagar) Center",
  address: "Near Bhumia Mandir, Bhumia Khera Colony, Roorkee"
}, {
  locationName: "Milap nagar Mohanpura, Roorkee",
  centerName: "Roorkee South Center",
  address: "Milapnagar, Mohanpura, Roorkee"
}, {
  locationName: "chandrapuri park Chow Mandi, Roorkee",
  centerName: "Chandrapuri Center",
  address: "Near Primary School, Sheetla Mata Mandir, Roorkee"
}, {
  locationName: "Geetanjali Vihar, Roorkee",
  centerName: "Ganeshpur Center",
  address: "Geetanjali Vihar, Ganesh Chowk, Station Rd, Roorkee"
}, {
  locationName: "Adarsh Nagar, Roorkee",
  centerName: "Sonalipuram Center ",
  address: "Jain Mandir Gali, Roorkee"
}];

/***/ }),

/***/ "9IM7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card text-center col-sm-12"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Intensified Mission IndraDhanush")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("This program aims to give 90% immunization coverage in India by 2020 so as to significantly reduce child mortality rate. We provide all necessary vaccines such as BCG (for tuberclosis), Pentavalent, Measles and Rubella.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning btn-md showGallery",
    on: {
      "click": _vm.visibleGallery
    }
  }, [_vm._v("Show Gallery")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated slideInUp",
      "leave-active-class": "animated fadeOutDown",
      "appear": ""
    }
  }, [(_vm.showGallery) ? _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "id": "first-close-btn"
    },
    on: {
      "click": _vm.hideGallery
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row gallery"
  }, [_vm._l((_vm.fileTitles), function(file) {
    return _c('div', {
      key: file.name,
      staticClass: "col-md-4 col-sm-6"
    }, [_c('a', {
      staticClass: "lightbox",
      attrs: {
        "href": __webpack_require__("G6Xb")("./" + (file.name))
      }
    }, [_c('img', {
      staticClass: "img-responsive rounded",
      attrs: {
        "src": __webpack_require__("G6Xb")("./" + (file.name)),
        "alt": file.alt
      }
    })])])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "id": "second-btn"
    },
    on: {
      "click": _vm.hideGallery
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 2)]) : _vm._e()])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9JlT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid current-campaign-div"
  }, [_vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row no-gutters"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 campaign-text"
  }, [_c('h4', [_vm._v("Intensified Mission Indradhanush")]), _vm._v(" "), _c('hr', {
    staticClass: "my-3"
  }), _vm._v(" "), _c('p', [_vm._v("In 2014, The Ministry of Health And Family Welfare in India launched this program to fully immunize children of age up to two years and pregnant women with all available vaccines. To help promote and implement this extremely beneficial program,\n        Friends has been organising various vaccination camps in Roorkee.\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-md btn-warning",
    attrs: {
      "tag": "button",
      "to": {
        path: '/events#cc'
      }
    }
  }, [_vm._v("See Our Gallery")])], 1)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h1', {
    staticClass: "campaign-heading"
  }, [_vm._v("Current Campaign")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-6 align-self-center"
  }, [_c('img', {
    staticClass: "img-fluid current-campaign-img",
    attrs: {
      "src": __webpack_require__("zNKM"),
      "alt": "Indra Dhanush"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9Snh":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./training-1.jpg": "QQvI",
	"./training-10.jpg": "ZQln",
	"./training-11.jpg": "R8Tm",
	"./training-12.jpg": "rab3",
	"./training-2.jpg": "xi1y",
	"./training-3.jpg": "AcAe",
	"./training-4.jpg": "pflM",
	"./training-5.jpg": "IMei",
	"./training-6.jpg": "I08b",
	"./training-7.jpg": "9jfT",
	"./training-8.jpg": "sXV+",
	"./training-9.jpg": "Gpma"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9Snh";

/***/ }),

/***/ "9jfT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/training-7.c1850e7.jpg";

/***/ }),

/***/ "AcAe":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/training-3.595f776.jpg";

/***/ }),

/***/ "AgHz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/partap-2.acbd6ac.jpg";

/***/ }),

/***/ "AhHC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reports_vue__ = __webpack_require__("eWrg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10282af9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Reports_vue__ = __webpack_require__("iLVK");
function injectStyle (ssrContext) {
  __webpack_require__("dZCz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10282af9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10282af9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Reports_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AyQr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/community-awareness.a7b3bc2.jpg";

/***/ }),

/***/ "BXmL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sign-2.b24d72e.jpg";

/***/ }),

/***/ "BdnU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bp-check.6cb7822.jpg";

/***/ }),

/***/ "BkFL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('my-carousel'), _vm._v(" "), _c('my-latestevents'), _vm._v(" "), _c('my-current-campaign'), _vm._v(" "), _c('my-awards')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bwa8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3.4a6be6c.jpg";

/***/ }),

/***/ "CF5V":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/h5.af5d895.jpg";

/***/ }),

/***/ "CY6h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Kishore_vue__ = __webpack_require__("hwtx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_345f59ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Kishore_vue__ = __webpack_require__("DFfO");
function injectStyle (ssrContext) {
  __webpack_require__("qk7d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-345f59ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Kishore_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_345f59ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Kishore_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CnMM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/house.bc2c014.jpg";

/***/ }),

/***/ "Cnv6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    $(".carousel").carousel({
      interval: 8000
    });
  }
});

/***/ }),

/***/ "DFfO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card text-center col-sm-12"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Understanding and Addressing Adolescent Needs (UDAAN)")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("A part of the larger program called Adolescent Reproductive and Sexual Health (ARSH), UDAAN focusses on educating the adolscent population about nutrition, reproductive health and hygiene, among other issues.Friends contributed to the training under\n        this program in Roorkee.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning btn-md showGallery",
    on: {
      "click": _vm.visibleGallery
    }
  }, [_vm._v("Show Gallery")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated slideInUp",
      "leave-active-class": "animated fadeOutDown",
      "appear": ""
    }
  }, [(_vm.showGallery) ? _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "id": "first-close-btn"
    },
    on: {
      "click": _vm.hideGallery
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row gallery"
  }, [_vm._l((_vm.fileTitles), function(file) {
    return _c('div', {
      key: file.name,
      staticClass: "col-md-4 col-sm-6"
    }, [_c('a', {
      staticClass: "lightbox",
      attrs: {
        "href": __webpack_require__("9Snh")("./" + (file.name))
      }
    }, [_c('img', {
      staticClass: "img-responsive rounded",
      attrs: {
        "src": __webpack_require__("9Snh")("./" + (file.name)),
        "alt": file.alt
      }
    })])])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "id": "second-btn"
    },
    on: {
      "click": _vm.hideGallery
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 2)]) : _vm._e()])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DLYX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fileTitles; });
var fileTitles = [{
  name: 'training-1.jpg',
  alt: "sign"
}, {
  name: 'training-2.jpg',
  alt: "taking to children"
}, {
  name: 'training-3.jpg',
  alt: "sharing wisdom"
}, {
  name: 'training-4.jpg',
  alt: 'talking about health'
}, {
  name: 'training-5.jpg',
  alt: 'sharing ideas'
}, {
  name: 'training-6.jpg',
  alt: 'Talking about nutrition'
}, {
  name: 'training-7.jpg',
  alt: 'Kids havin fun'
}, {
  name: 'training-8.jpg',
  alt: 'Light lecture'
}, {
  name: "training-9.jpg",
  alt: 'kids listening'
}, {
  name: 'training-10.jpg',
  alt: 'practicising more knowledge'
}, {
  name: "training-11.jpg",
  alt: 'kids grasping knowledge about their issues'
}, {
  name: 'training-12.jpg',
  alt: 'showing charts'
}];

/***/ }),

/***/ "DbT+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__("m+ok");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7da17eb6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__("ei30");
function injectStyle (ssrContext) {
  __webpack_require__("WuOv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7da17eb6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7da17eb6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DuMy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EGie":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentCampaign_vue__ = __webpack_require__("ntQ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e76ab8f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentCampaign_vue__ = __webpack_require__("9JlT");
function injectStyle (ssrContext) {
  __webpack_require__("FGLC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentCampaign_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e76ab8f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentCampaign_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Enlp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/team.847ab29.jpg";

/***/ }),

/***/ "EsH0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kids-many.842d8a6.jpg";

/***/ }),

/***/ "F5Z9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FCaU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/14.1d8b197.jpg";

/***/ }),

/***/ "FGLC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FRxS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/6.4ce141f.jpg";

/***/ }),

/***/ "FYEm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5.d684166.jpg";

/***/ }),

/***/ "FpNk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/8.2946273.jpg";

/***/ }),

/***/ "FuDk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "G6XM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/7.7925846.jpg";

/***/ }),

/***/ "G6Xb":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./advising.jpg": "o+p8",
	"./aware.jpg": "gaAv",
	"./certificate.jpg": "3qJl",
	"./cry.jpg": "pFFJ",
	"./dad-kid.jpg": "PZup",
	"./group.jpg": "HzNl",
	"./happy-doc.jpg": "u9fR",
	"./hussle.jpg": "NulR",
	"./line.jpg": "2Z8I",
	"./muslim-2.jpg": "ZwXt",
	"./old-doc.jpg": "syno",
	"./patients.jpg": "6iiC",
	"./ranjana.jpg": "ulPN",
	"./room.jpg": "owuG",
	"./sign-2.jpg": "tUis",
	"./team-2.jpg": "68Zu",
	"./team.jpg": "Enlp",
	"./tika.jpg": "bgrt"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "G6Xb";

/***/ }),

/***/ "GB7n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeInRight",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Our Campaigns & Events")])])]), _vm._v(" "), _c('Cleaniness'), _vm._v(" "), _c('a', {
    attrs: {
      "id": "cc"
    }
  }), _vm._v(" "), _c('IndraDhanush'), _vm._v(" "), _c('a', {
    attrs: {
      "id": "mas"
    }
  }), _vm._v(" "), _c('Mas'), _vm._v(" "), _c('a', {
    attrs: {
      "id": "wad"
    }
  }), _vm._v(" "), _c('Wad'), _vm._v(" "), _c('Kishore'), _vm._v(" "), _c('Asha'), _vm._v(" "), _c('SpecialCamps')], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GZ5q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Events_vue__ = __webpack_require__("PEyK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15252ea9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Events_vue__ = __webpack_require__("GB7n");
function injectStyle (ssrContext) {
  __webpack_require__("WQBN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15252ea9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Events_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15252ea9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Events_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Gpma":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/training-9.40a089d.jpg";

/***/ }),

/***/ "Gq0J":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/doc-prescrip.295402b.jpg";

/***/ }),

/***/ "HCTz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "HILi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ti-6.2052c97.jpg";

/***/ }),

/***/ "HKyT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HSx0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/care-bed.702dfda.jpg";

/***/ }),

/***/ "HzNl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/group.82cf0d3.jpg";

/***/ }),

/***/ "I08b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/training-6.14c1ce4.jpg";

/***/ }),

/***/ "I6H7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IGYC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fileTitles; });
var fileTitles = [{
  name: "sign.jpg",
  alt: "World AIDS Day signage"
}, {
  name: "staff-kids.jpg",
  alt: "Our staff helping kids in slums"
}, {
  name: "h2.jpg",
  alt: 'Treat addicts nicely'
}, {
  name: 'h3.jpg',
  alt: 'people in favour of addicts'
}, {
  name: 'h7.jpg',
  alt: 'Drug addicts protesting'
}, {
  name: 'h8.jpg',
  alt: 'expecting respect'
}, {
  name: 'h4.jpg',
  alt: 'spreading awareness'
}, {
  name: 'h9.jpg',
  alt: 'Police'
}, {
  name: 'h10.jpg',
  alt: 'Police'
}, {
  name: "h12.jpg",
  alt: 'Police'
}, {
  name: 'h6.jpg',
  alt: 'AIDS'
}, {
  name: 'h5.jpg',
  alt: 'talking about AIDS'
}];

/***/ }),

/***/ "IIjP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kid-vaccine.9529195.jpg";

/***/ }),

/***/ "IMei":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/training-5.25ce43a.jpg";

/***/ }),

/***/ "IVg9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card text-center col-sm-12",
    attrs: {
      "id": "aidsDay"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("World AIDS Day")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("As part of our Hridaya Project, we organised this event on World AIDS Day to distribute books, food and necessary supplies to the children in the slums near the main Haridwar city. This was carried out on 1 December 2013.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning btn-md showGallery",
    on: {
      "click": _vm.visibleGallery
    }
  }, [_vm._v("Show Gallery")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated slideInUp",
      "leave-active-class": "animated fadeOutDown",
      "appear": ""
    }
  }, [(_vm.showGallery) ? _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "id": "first-close-btn"
    },
    on: {
      "click": _vm.hideGallery
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row gallery"
  }, [_vm._l((_vm.fileTitles), function(file) {
    return _c('div', {
      key: file.name,
      staticClass: "col-md-4 col-sm-6"
    }, [_c('a', {
      staticClass: "lightbox",
      attrs: {
        "href": __webpack_require__("upEf")("./" + (file.name))
      }
    }, [_c('img', {
      staticClass: "img-responsive rounded",
      attrs: {
        "src": __webpack_require__("upEf")("./" + (file.name)),
        "alt": file.alt
      }
    })])])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "id": "second-btn"
    },
    on: {
      "click": _vm.hideGallery
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 2)]) : _vm._e()])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Iirp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/16.609561d.jpg";

/***/ }),

/***/ "ImdG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-out.1ec068f.jpg";

/***/ }),

/***/ "JdAK":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./0.jpg": "qpAe",
	"./1.jpg": "3ALm",
	"./10.jpg": "srEc",
	"./11.jpg": "+v6S",
	"./12.jpg": "6pC1",
	"./13.jpg": "0sOa",
	"./14.jpg": "akME",
	"./15.jpg": "hO7p",
	"./16.jpg": "83qc",
	"./17.jpg": "29qX",
	"./2.jpg": "5emF",
	"./3.jpg": "x74d",
	"./4.jpg": "JkWT",
	"./5.jpg": "Nnbo",
	"./6.jpg": "h9Gp",
	"./7.jpg": "NCIz",
	"./8.jpg": "FpNk",
	"./9.jpg": "aClS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "JdAK";

/***/ }),

/***/ "JeQr":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./h1.jpg": "lojV",
	"./h10.jpg": "rxOq",
	"./h11.jpg": "ltwe",
	"./h12.jpg": "buVD",
	"./h2.jpg": "YTg1",
	"./h3.jpg": "+A6G",
	"./h4.jpg": "pj53",
	"./h5.jpg": "CF5V",
	"./h6.jpg": "c2JK",
	"./h7.jpg": "ZG7P",
	"./h8.jpg": "UkwA",
	"./h9.jpg": "eiMS",
	"./sign.jpg": "mfZc",
	"./staff-kids.jpg": "qL50"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "JeQr";

/***/ }),

/***/ "JkWT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4.dccb827.jpg";

/***/ }),

/***/ "JvmC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/patient-line-2.b2f9b8c.jpg";

/***/ }),

/***/ "KIuW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/16.ab4eb87.jpg";

/***/ }),

/***/ "KYqO":
/***/ (function(module, exports) {

module.exports = {"_from":"elliptic@^6.0.0","_id":"elliptic@6.4.0","_inBundle":false,"_integrity":"sha1-ysmvh2LIWDYYcAPI3+GT5eLq5d8=","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"elliptic@^6.0.0","name":"elliptic","escapedName":"elliptic","rawSpec":"^6.0.0","saveSpec":null,"fetchSpec":"^6.0.0"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.4.0.tgz","_shasum":"cac9af8762c85836187003c8dfe193e5e2eae5df","_spec":"elliptic@^6.0.0","_where":"/Users/Nishant/Desktop/friends/node_modules/browserify-sign","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"bundleDependencies":false,"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"deprecated":false,"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.4.0"}

/***/ }),

/***/ "LLFd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/chinese-doc.eb01417.jpg";

/***/ }),

/***/ "LQsL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/11.a3e2a4c.jpg";

/***/ }),

/***/ "LgIY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_baguetteBox_js__ = __webpack_require__("/5fg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_baguetteBox_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_baguetteBox_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Wad_data_js__ = __webpack_require__("2GjZ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showGallery: false,
      fileTitles: __WEBPACK_IMPORTED_MODULE_1__Wad_data_js__["a" /* fileTitles */]
    };
  },

  methods: {
    visibleGallery: function visibleGallery() {
      this.showGallery = true;
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_0_baguetteBox_js___default.a.run('.gallery');
      }, 1000);
    },
    hideGallery: function hideGallery() {
      this.showGallery = false;
      window.scrollTo(0, 650);
    }
  }
});

/***/ }),

/***/ "LkY1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4-people.4edf06e.jpg";

/***/ }),

/***/ "M8Mp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    attrs: {
      "id": "specialCamps"
    }
  }, [_c('div', {
    staticClass: "card text-center col-sm-12"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Special Health Camps")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("We run special health camps quite often as an outreach to the sick and needy who aren't able to make it to our health centres. These are on going camps as part of our Urban Primary health Centres Project. We run 14 of these camps per month in different\n        areas in Roorkee.\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning btn-md showGallery",
    on: {
      "click": _vm.visibleGallery
    }
  }, [_vm._v("Show Gallery")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated slideInUp",
      "leave-active-class": "animated fadeOutDown",
      "appear": ""
    }
  }, [(_vm.showGallery) ? _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "id": "first-close-btn"
    },
    on: {
      "click": _vm.hideGallery
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row gallery"
  }, [_vm._l((_vm.fileTitles), function(file) {
    return _c('div', {
      key: file.name,
      staticClass: "col-md-4 col-sm-6"
    }, [_c('a', {
      staticClass: "lightbox",
      attrs: {
        "href": __webpack_require__("JdAK")("./" + (file.name))
      }
    }, [_c('img', {
      staticClass: "img-responsive rounded",
      attrs: {
        "src": __webpack_require__("JdAK")("./" + (file.name)),
        "alt": file.alt
      }
    })])])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "id": "second-btn"
    },
    on: {
      "click": _vm.hideGallery
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 2)]) : _vm._e()])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_180d25be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("PMax");
function injectStyle (ssrContext) {
  __webpack_require__("DuMy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_180d25be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MDv7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card text-center col-sm-12"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("ASHA Training and Capacity Building")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("Accredited Social Health Activists (ASHA's) are primarily women selected from their respective villages (one per village/locality) who work as an interface between the community and the public health system. This program aims to develop further\n        skills in ASHA's so they can better represent their communities. Friends contributed to the training in Roorkee.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning btn-md showGallery",
    on: {
      "click": _vm.visibleGallery
    }
  }, [_vm._v("Show Gallery")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated slideInUp",
      "leave-active-class": "animated fadeOutDown",
      "appear": ""
    }
  }, [(_vm.showGallery) ? _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "id": "first-close-btn"
    },
    on: {
      "click": _vm.hideGallery
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row gallery"
  }, [_vm._l((_vm.fileTitles), function(file) {
    return _c('div', {
      key: file.name,
      staticClass: "col-md-4 col-sm-6"
    }, [_c('a', {
      staticClass: "lightbox",
      attrs: {
        "href": __webpack_require__("hYMR")("./" + (file.name))
      }
    }, [_c('img', {
      staticClass: "img-responsive rounded",
      attrs: {
        "src": __webpack_require__("hYMR")("./" + (file.name)),
        "alt": file.alt
      }
    })])])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "id": "second-btn"
    },
    on: {
      "click": _vm.hideGallery
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 2)]) : _vm._e()])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MIpg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/preaching-2.c411203.jpg";

/***/ }),

/***/ "MNEl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NCIz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/7.13f1f6f.jpg";

/***/ }),

/***/ "NFTS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/partap.c9497d8.jpg";

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]
  }
});

/***/ }),

/***/ "Nh0a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/award-lady.dcf3eec.jpg";

/***/ }),

/***/ "Nnbo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5.2acbaee.jpg";

/***/ }),

/***/ "NulR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hussle.ed983f5.jpg";

/***/ }),

/***/ "O/gy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/doc-kid-closeup-2.a660207.jpg";

/***/ }),

/***/ "O4y2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-expand-lg sticky-top"
  }, [_c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbarToggleExternalContent"
    }
  }, [_c('router-link', {
    staticClass: "align-top img-fluid my-logo d-none d-md-block float-md-left float-lg-none",
    attrs: {
      "tag": "img",
      "to": {
        path: '/'
      },
      "src": "/static/my-logo-v1.png",
      "alt": "Friends"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "navbar-nav justify-content-center"
  }, [_c('li', {
    staticClass: "nav-item active"
  }, [_c('svg', {
    attrs: {
      "fill": "#000000",
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/'
      },
      "active-class": "active",
      "exact": ""
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('svg', {
    attrs: {
      "fill": "#000000",
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z"
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/projects'
      },
      "exact": "",
      "active-class": "active"
    }
  }, [_vm._v("Projects")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('svg', {
    attrs: {
      "fill": "#000000",
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/about'
      },
      "exact": "",
      "active-class": "active"
    }
  }, [_vm._v("About")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('svg', {
    attrs: {
      "fill": "#000000",
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/contact'
      },
      "exact": "",
      "active-class": "active"
    }
  }, [_vm._v("Contact")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('svg', {
    attrs: {
      "fill": "#000000",
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/reports'
      },
      "exact": "",
      "active-class": "active"
    }
  }, [_vm._v("Reports")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('svg', {
    attrs: {
      "fill": "#000000",
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/events'
      },
      "exact": "",
      "active-class": "active"
    }
  }, [_vm._v("Events")])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "menu-icon-div"
  }, [_c('button', {
    staticClass: "navbar-toggler",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbarToggleExternalContent",
      "aria-controls": "navbarToggleExternalContent",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  }, [_c('svg', {
    attrs: {
      "fill": "#fff",
      "height": "40",
      "viewBox": "0 0 24 24",
      "width": "40",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })])])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O9HZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/staff-kids.101132d.jpg";

/***/ }),

/***/ "OSu/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/asha-aware.912278b.jpg";

/***/ }),

/***/ "Oc/I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel slide",
    attrs: {
      "id": "carouselExampleIndicators",
      "data-ride": "carousel"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "carousel-inner"
  }, [_c('div', {
    staticClass: "carousel-item active"
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": __webpack_require__("/V33"),
      "alt": "Friends Forever"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "carousel-caption",
    attrs: {
      "id": "first-caption"
    }
  }, [_c('h1', {
    staticClass: "display-4"
  }, [_vm._v("FRIENDS")]), _vm._v(" "), _c('p', {
    staticClass: "d-none d-md-block"
  }, [_vm._v("Making A Better Society")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-md btn-warning",
    attrs: {
      "tag": "button",
      "to": {
        path: '/about'
      },
      "exact": ""
    }
  }, [_vm._v("Discover More")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "carousel-item"
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": __webpack_require__("c/6a"),
      "alt": "Children in Slums"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "carousel-caption",
    attrs: {
      "id": "second-caption"
    }
  }, [_c('h1', {
    staticClass: "display-4"
  }, [_vm._v("UPSC")]), _vm._v(" "), _c('p', {
    staticClass: "d-none d-md-block"
  }, [_vm._v("Currently running Urban Primary Health Centers")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-md btn-warning",
    attrs: {
      "tag": "button",
      "to": {
        path: '/projects'
      },
      "exact": ""
    }
  }, [_vm._v("Get More details")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "carousel-item"
  }, [_c('img', {
    staticClass: "w-100 d-block",
    attrs: {
      "src": __webpack_require__("O/gy"),
      "alt": "Special Health Camps"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "carousel-caption",
    attrs: {
      "id": "third-caption"
    }
  }, [_c('h1', {
    staticClass: "display-4"
  }, [_vm._v("CAMPS")]), _vm._v(" "), _c('p', {
    staticClass: "d-none d-md-block"
  }, [_vm._v("To improve health of poors in urban slums")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-md btn-warning",
    attrs: {
      "tag": "button",
      "to": {
        path: '/events#specialCamps'
      },
      "exact": ""
    }
  }, [_vm._v("View our gallery")])], 1)])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "carousel-indicators"
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "data-target": "#carouselExampleIndicators",
      "data-slide-to": "0"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-target": "#carouselExampleIndicators",
      "data-slide-to": "1"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-target": "#carouselExampleIndicators",
      "data-slide-to": "2"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OdUv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_baguetteBox_js__ = __webpack_require__("/5fg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_baguetteBox_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_baguetteBox_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Cleaniness_data_js__ = __webpack_require__("eEMR");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showGallery: false,
      fileTitles: __WEBPACK_IMPORTED_MODULE_1__Cleaniness_data_js__["a" /* fileTitles */]
    };
  },

  methods: {
    visibleGallery: function visibleGallery() {
      this.showGallery = true;
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_0_baguetteBox_js___default.a.run('.gallery');
        console.log("baguebox running");
      }, 1000);
    },
    hideGallery: function hideGallery() {
      this.showGallery = false;
      window.scrollTo(0, 70);
    }
  }
});

/***/ }),

/***/ "Oqb/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OwVm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hridya_vue__ = __webpack_require__("XWiT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f06e92a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Hridya_vue__ = __webpack_require__("kX+5");
function injectStyle (ssrContext) {
  __webpack_require__("VIUJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f06e92a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hridya_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f06e92a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Hridya_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "P0G/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Hridya_Hridya_vue__ = __webpack_require__("OwVm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Telecounselling_Telecounselling_vue__ = __webpack_require__("qQoC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Ti_Ti_vue__ = __webpack_require__("/OoD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Uphc_Uphc_vue__ = __webpack_require__("l84l");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Hridya: __WEBPACK_IMPORTED_MODULE_0__Hridya_Hridya_vue__["a" /* default */],
    Telecounselling: __WEBPACK_IMPORTED_MODULE_1__Telecounselling_Telecounselling_vue__["a" /* default */],
    Ti: __WEBPACK_IMPORTED_MODULE_2__Ti_Ti_vue__["a" /* default */],
    Uphc: __WEBPACK_IMPORTED_MODULE_3__Uphc_Uphc_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "PEyK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Cleaniness_Cleaniness_vue__ = __webpack_require__("5k+t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__IndraDhanush_IndraDhanush_vue__ = __webpack_require__("xskE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Mas_Mas_vue__ = __webpack_require__("jDLz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Wad_Wad_vue__ = __webpack_require__("aV/z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__KishoreTraining_Kishore_vue__ = __webpack_require__("CY6h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AshaTraining_Asha_vue__ = __webpack_require__("qQa3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SpecialCamps_SpecialCamps_vue__ = __webpack_require__("3Be5");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Cleaniness: __WEBPACK_IMPORTED_MODULE_0__Cleaniness_Cleaniness_vue__["a" /* default */],
    IndraDhanush: __WEBPACK_IMPORTED_MODULE_1__IndraDhanush_IndraDhanush_vue__["a" /* default */],
    Mas: __WEBPACK_IMPORTED_MODULE_2__Mas_Mas_vue__["a" /* default */],
    Wad: __WEBPACK_IMPORTED_MODULE_3__Wad_Wad_vue__["a" /* default */],
    SpecialCamps: __WEBPACK_IMPORTED_MODULE_6__SpecialCamps_SpecialCamps_vue__["a" /* default */],
    Kishore: __WEBPACK_IMPORTED_MODULE_4__KishoreTraining_Kishore_vue__["a" /* default */],
    Asha: __WEBPACK_IMPORTED_MODULE_5__AshaTraining_Asha_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "PMax":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "app"
    }
  }, [_c('app-header'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('app-footer')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PZup":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dad-kid.c935980.jpg";

/***/ }),

/***/ "PvAO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/20.cba35de.jpg";

/***/ }),

/***/ "QDfD":
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ "QQvI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/training-1.055debf.jpg";

/***/ }),

/***/ "Qs9i":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lady-happy.b3fc2a0.jpg";

/***/ }),

/***/ "R8Tm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/training-11.fde4e5e.jpg";

/***/ }),

/***/ "RLVN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bp-check-3.23c48da.jpg";

/***/ }),

/***/ "Rb0y":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/food-2.31da6af.jpg";

/***/ }),

/***/ "Ric7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_baguetteBox_js__ = __webpack_require__("/5fg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_baguetteBox_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_baguetteBox_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import {
//   fileTitles
// } from './Hridya-data.js'
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showGallery: false
      // fileTitles: fileTitles
    };
  },

  methods: {
    visibleGallery: function visibleGallery() {
      this.showGallery = true;

      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_0_baguetteBox_js___default.a.run('.gallery');
        console.log("baguebox running");
      }, 1500);
    },
    hideGallery: function hideGallery() {
      this.showGallery = false;
      window.scrollTo(0, 700);
    }
  }
});

/***/ }),

/***/ "S3oR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/17.423b931.jpg";

/***/ }),

/***/ "S4Jt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ti-12.fd3f365.jpg";

/***/ }),

/***/ "S57C":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kids-books.d0b35c0.jpg";

/***/ }),

/***/ "SQJG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/9.0872674.jpg";

/***/ }),

/***/ "SWvm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/food.1eb34b5.jpg";

/***/ }),

/***/ "SdWy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ti-10.0ed99a9.jpg";

/***/ }),

/***/ "Shms":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ti-8.6932679.jpg";

/***/ }),

/***/ "SvNe":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/doc-kid-ranjana.3d6cded.jpg";

/***/ }),

/***/ "TEpQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ti-4.822f8da.jpg";

/***/ }),

/***/ "TNr5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kids-group.eb142cc.jpg";

/***/ }),

/***/ "TVmP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__("UthT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_450db851_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__("2g6c");
function injectStyle (ssrContext) {
  __webpack_require__("MNEl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-450db851"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_450db851_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TaK+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/18.8cb5526.jpg";

/***/ }),

/***/ "TbFu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/7.2434bcc.jpg";

/***/ }),

/***/ "Tnwi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UkwA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/h8.3d1fe57.jpg";

/***/ }),

/***/ "UthT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "V7lH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mas-main.eae636c.jpg";

/***/ }),

/***/ "VIUJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VUxD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/15.181e1e3.jpg";

/***/ }),

/***/ "Va99":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_baguetteBox_js__ = __webpack_require__("/5fg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_baguetteBox_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_baguetteBox_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Ti_data_js__ = __webpack_require__("4ifg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showGallery: false,
      fileTitles: __WEBPACK_IMPORTED_MODULE_1__Ti_data_js__["a" /* fileTitles */]
    };
  },

  methods: {
    visibleGallery: function visibleGallery() {
      this.showGallery = true;
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_0_baguetteBox_js___default.a.run('.gallery');
        console.log("baguebox running");
      }, 1500);
    },
    hideGallery: function hideGallery() {
      this.showGallery = false;
      window.scrollTo(0, 450);
    }
  }
});

/***/ }),

/***/ "Vovp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kids-poor.555778f.jpg";

/***/ }),

/***/ "VvCe":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/preeti.66ee095.jpg";

/***/ }),

/***/ "W2A4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__google_maps__ = __webpack_require__("PoCf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Data_Locations_js__ = __webpack_require__("8tyy");
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {

    var googleMapsClient = __WEBPACK_IMPORTED_MODULE_0__google_maps___default.a.createClient({
      key: 'AIzaSyAQB-EtslpfEQHPA7Is9_dBqNJUKilUiTc'
    });

    var map;
    var mapDiv = document.getElementById("map");
    map = new google.maps.Map(mapDiv, {
      center: {
        lat: 29.8648599,
        lng: 77.8965787
      },
      zoom: 13
    });

    __WEBPACK_IMPORTED_MODULE_1__Data_Locations_js__["a" /* centersArr */].forEach(function (e) {
      googleMapsClient.geocode({
        address: e.locationName
      }, function (err, res) {
        if (!err) {
          var mycoords = res.json.results[0].geometry.location;
          var marker = new google.maps.Marker({
            position: mycoords,
            map: map,
            label: '',
            icon: 'static/maps-icon.png'
          });
          var infoWindow = new google.maps.InfoWindow({
            content: '<div class="infoWindow-text" style="font-family: avenir;width:350px !important;height:170px !important">\n            <h5 style="text-align:center;padding-top: 2%">' + e.centerName + ' <i class="fa fa-plus-square" style="font-size:24px;color:red"> </i></h5>\n            <hr>\n              <p style="letter-spacing: 1px"><span style="font-weight: bold">Address:</span> ' + e.address + '</p>\n              <p style="letter-spacing: 1px"><span style="font-weight: bold">Phone:</span> +91 8171100382</p>\n              <p style="letter-spacing: 1px"><span style="font-weight: bold">Email:</span> friendshwr@gmail.com</p>\n            </div>'
          });
          marker.addListener("click", function () {
            infoWindow.open(map, marker);
          });
        }
      });
    });
  }
});

/***/ }),

/***/ "WO7R":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kids.ece4ea9.jpg";

/***/ }),

/***/ "WQBN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WZ4d":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4.f799566.jpg";

/***/ }),

/***/ "Wefo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/path.6fedb55.jpg";

/***/ }),

/***/ "WqPl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fileTitles; });
var fileTitles = [{
  name: 'asha-aware-2.jpg',
  alt: 'Asha spreading awareness about health'
}, {
  name: "asha-aware.jpg",
  alt: 'Asha helping locals'
}, {
  name: 'baby-weigh.jpg',
  alt: 'Weighing a new born'
}, {
  name: 'bp-check-2.jpg',
  alt: 'Helping a patient'
}, {
  name: 'kid-inject.jpg',
  alt: 'Kid Vaccination'
}, {
  name: 'kid-vaccine.jpg',
  alt: 'Child Vaccination'
}, {
  name: 'care-bed.jpg',
  alt: 'Resting bed for patients'
}, {
  name: 'docs-sit.jpg',
  alt: 'Our Helpful Team'
}, {
  name: 'bp-happy.jpg',
  alt: 'Happy Patients'
}, {
  name: 'bp-check-3.jpg',
  alt: 'Blood Pressure check up'
}, {
  name: 'incubators.jpg',
  alt: 'Incubators for samples'
}, {
  name: "shivir.jpg",
  alt: 'One of our Health Camps'
}, {
  name: 'lab-technician.jpg',
  alt: 'Our Lab Staff'
}, {
  name: 'sign-4.jpg',
  alt: 'Ganeshpur Center'
}, {
  name: 'shivir-2.jpg',
  alt: 'Health Camps'
}];

/***/ }),

/***/ "WuOv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X4xA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/rahul.2416b27.jpg";

/***/ }),

/***/ "XWiT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_baguetteBox_js__ = __webpack_require__("/5fg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_baguetteBox_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_baguetteBox_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Hridya_data_js__ = __webpack_require__("IGYC");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showGallery: false,
      fileTitles: __WEBPACK_IMPORTED_MODULE_1__Hridya_data_js__["a" /* fileTitles */]
    };
  },

  methods: {
    visibleGallery: function visibleGallery() {
      this.showGallery = true;

      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_0_baguetteBox_js___default.a.run('.gallery');
        console.log("baguebox running");
      }, 1500);
    },
    hideGallery: function hideGallery() {
      this.showGallery = false;
      window.scrollTo(0, 200);
    }
  }
});

/***/ }),

/***/ "Xg8S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XrJi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YCJZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kid-dad.9356efc.jpg";

/***/ }),

/***/ "YJwR":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./asha-aware-2.jpg": "vss5",
	"./asha-aware.jpg": "OSu/",
	"./baby-weigh.jpg": "xg8S",
	"./bp-check-2.jpg": "kK0n",
	"./bp-check-3.jpg": "RLVN",
	"./bp-check.jpg": "BdnU",
	"./bp-happy.jpg": "ZiaY",
	"./care-bed.jpg": "HSx0",
	"./class.jpg": "YmIU",
	"./doc-muslim.jpg": "+JGl",
	"./doc-prescrip.jpg": "Gq0J",
	"./docs-sit.jpg": "d9dE",
	"./incubators.jpg": "ym+s",
	"./kid-inject.jpg": "sFe7",
	"./kid-vaccine.jpg": "IIjP",
	"./lab-technician.jpg": "17lt",
	"./patient-line-2.jpg": "JvmC",
	"./patient-line.jpg": "ufs2",
	"./shivir-2.jpg": "xpWa",
	"./shivir-3.jpg": "63Rv",
	"./shivir-4.jpg": "aJLd",
	"./shivir.jpg": "6u/w",
	"./sign-2.jpg": "BXmL",
	"./sign-3.jpg": "Z2gs",
	"./sign-4.jpg": "gCoM",
	"./sign.jpg": "w5N9",
	"./staff-uphc.jpg": "/I9Q"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YJwR";

/***/ }),

/***/ "YTg1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/h2.d7fa256.jpg";

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home_Home__ = __webpack_require__("wqTG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_About_About__ = __webpack_require__("DbT+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Contact_Contact__ = __webpack_require__("/kbf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Projects_Projects__ = __webpack_require__("zqmC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Reports__ = __webpack_require__("AhHC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Events_Events__ = __webpack_require__("GZ5q");









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home_Home__["a" /* default */]
  }, {
    path: '/about',
    component: __WEBPACK_IMPORTED_MODULE_3__components_About_About__["a" /* default */]
  }, {
    path: '/contact',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Contact_Contact__["a" /* default */]
  }, {
    path: '/projects',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Projects_Projects__["a" /* default */]
  }, {
    path: '/reports',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Reports__["a" /* default */]
  }, {
    path: "/events",
    component: __WEBPACK_IMPORTED_MODULE_7__components_Events_Events__["a" /* default */]
  }, {
    path: '*',
    redirect: '/'
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      };
    }
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  }
}));

/***/ }),

/***/ "YeJh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YmIU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/class.6eadf0c.jpg";

/***/ }),

/***/ "Z+mJ":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./3-closeup.jpg": "vNx4",
	"./3-in.jpg": "08G3",
	"./3-out.jpg": "ImdG",
	"./4-people.jpg": "LkY1",
	"./5-out.jpg": "5iTp",
	"./bright.jpg": "m8T5",
	"./fun.jpg": "gHcG",
	"./girl-power.jpg": "4XED",
	"./group-bricks.jpg": "zNct",
	"./many-in.jpg": "xr0W",
	"./preeti.jpg": "VvCe",
	"./rahul-2.jpg": "tlJR",
	"./rahul.jpg": "X4xA",
	"./random.jpg": "+Q9R",
	"./single-girl.jpg": "npb6"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Z+mJ";

/***/ }),

/***/ "Z2gs":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sign-3.30dd17e.jpg";

/***/ }),

/***/ "ZG7P":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/h7.f253cb4.jpg";

/***/ }),

/***/ "ZL6z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card text-center col-sm-12"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Targeted Intervention Project")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("Assigned to us by Uttarkhand State AIDS Control Society in Dehradun, this project aimed at reducing the transmission of AIDS in slum areas around Haridwar. Through street plays and by providing medical help, we raised awareness on AIDS and ways\n        to prevent it.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning btn-md showGallery",
    on: {
      "click": _vm.visibleGallery
    }
  }, [_vm._v("Show Gallery")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated slideInUp",
      "leave-active-class": "animated fadeOutDown",
      "appear": ""
    }
  }, [(_vm.showGallery) ? _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "id": "first-close-btn"
    },
    on: {
      "click": _vm.hideGallery
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row gallery"
  }, [_vm._l((_vm.fileTitles), function(file) {
    return _c('div', {
      key: file.name,
      staticClass: "col-md-4 col-sm-6"
    }, [_c('a', {
      staticClass: "lightbox",
      attrs: {
        "href": __webpack_require__("rHlQ")("./" + (file.name))
      }
    }, [_c('img', {
      staticClass: "img-responsive rounded",
      attrs: {
        "src": __webpack_require__("rHlQ")("./" + (file.name)),
        "alt": file.alt
      }
    })])])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "id": "second-btn"
    },
    on: {
      "click": _vm.hideGallery
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 2)]) : _vm._e()])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZQln":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/training-10.c9d104b.jpg";

/***/ }),

/***/ "ZiaY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bp-happy.e343f46.jpg";

/***/ }),

/***/ "ZwXt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/muslim-2.045bc11.jpg";

/***/ }),

/***/ "aClS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/9.f0d98e9.jpg";

/***/ }),

/***/ "aJLd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shivir-4.815eecb.jpg";

/***/ }),

/***/ "aV/z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wad_vue__ = __webpack_require__("LgIY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_822674b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Wad_vue__ = __webpack_require__("IVg9");
function injectStyle (ssrContext) {
  __webpack_require__("8Jz3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-822674b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wad_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_822674b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Wad_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aW8E":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/book-kid.5d0d81f.jpg";

/***/ }),

/***/ "aeb7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.3969fe0.jpg";

/***/ }),

/***/ "afiw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_baguetteBox_js__ = __webpack_require__("/5fg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_baguetteBox_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_baguetteBox_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__IndraDhanush_data_js__ = __webpack_require__("2PRq");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showGallery: false,
      fileTitles: __WEBPACK_IMPORTED_MODULE_1__IndraDhanush_data_js__["a" /* fileTitles */]
    };
  },

  methods: {
    visibleGallery: function visibleGallery() {
      this.showGallery = true;
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_0_baguetteBox_js___default.a.run('.gallery');
        console.log("baguebox running");
      }, 1000);
    },
    hideGallery: function hideGallery() {
      this.showGallery = false;
      window.scrollTo(0, 150);
    }
  }
});

/***/ }),

/***/ "akME":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/14.153c0fc.jpg";

/***/ }),

/***/ "bgrt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tika.61dae3f.jpg";

/***/ }),

/***/ "bnlo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/study.a22d64d.jpg";

/***/ }),

/***/ "buVD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/h12.adcaa1f.jpg";

/***/ }),

/***/ "c/6a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/change-2.6a5257b.jpg";

/***/ }),

/***/ "c2JK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/h6.dfc0c13.jpg";

/***/ }),

/***/ "c7Dw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/12.5c6d341.jpg";

/***/ }),

/***/ "cWu0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kids-sit.862e1b9.jpg";

/***/ }),

/***/ "cjjS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card text-center col-sm-12"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Swachh Bharat Abhiyan (Clean India Mission)")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("In accordance with Government of India's campaign for cleaning India, we demonstrated our participation by organising various cleaning campaigns in and around Roorkee.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning btn-md showGallery",
    on: {
      "click": _vm.visibleGallery
    }
  }, [_vm._v("Show Gallery")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated slideInUp",
      "leave-active-class": "animated fadeOutDown",
      "appear": ""
    }
  }, [(_vm.showGallery) ? _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "id": "first-close-btn"
    },
    on: {
      "click": _vm.hideGallery
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row gallery"
  }, [_vm._l((_vm.fileTitles), function(file) {
    return _c('div', {
      key: file.name,
      staticClass: "col-md-4 col-sm-6"
    }, [_c('a', {
      staticClass: "lightbox",
      attrs: {
        "href": __webpack_require__("Z+mJ")("./" + (file.name))
      }
    }, [_c('img', {
      staticClass: "img-responsive rounded",
      attrs: {
        "src": __webpack_require__("Z+mJ")("./" + (file.name)),
        "alt": file.alt
      }
    })])])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "id": "second-btn"
    },
    on: {
      "click": _vm.hideGallery
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 2)]) : _vm._e()])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cthV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ti-2.d6f9bf6.jpg";

/***/ }),

/***/ "d9dE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/docs-sit.5ee6c0f.jpg";

/***/ }),

/***/ "dZCz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eEMR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fileTitles; });
var fileTitles = [{
  name: '3-closeup.jpg',
  alt: 'Colleagues Cleaning indoors'
}, {
  name: '3-out.jpg',
  alt: '3 colleagues outdoors'
}, {
  name: '4-people.jpg',
  alt: 'Team of 4 cleaning'
}, {
  name: 'bright.jpg',
  alt: 'Colleagues cleaning'
}, {
  name: 'fun.jpg',
  alt: 'Having fun'
}, {
  name: 'girl-power.jpg',
  alt: 'Girls cleaning'
}, {
  name: 'group-bricks.jpg',
  alt: 'Cleaning crew'
}, {
  name: "3-in.jpg",
  alt: 'Three staff members cleaning'
}, {
  name: '5-out.jpg',
  alt: 'Team of 5 cleaning'
}, {
  name: 'rahul-2.jpg',
  alt: 'Helping Locals'
}, {
  name: 'many-in.jpg',
  alt: 'Group cleaning'
}, {
  name: "preeti.jpg",
  alt: 'Supervising others cleaning'
}, {
  name: 'rahul.jpg',
  alt: 'Having fun while cleaning'
}, {
  name: 'random.jpg',
  alt: 'People Cleaning'
}, {
  name: 'single-girl.jpg',
  alt: "Single girl Cleaning"
}];

/***/ }),

/***/ "eWrg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "ei30":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeInRight",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "container",
    attrs: {
      "enter-active-area": "animated fadeIn"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h1', {
    staticClass: "text-center about-us-heading"
  }, [_vm._v("Who We Are")]), _vm._v(" "), _c('h5', {
    staticClass: "text-center"
  }, [_vm._v("Forum for Rural Infrastructural, Environmental & National Development Society (FRIENDS)")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-6 text-tile"
  }, [_c('h5', [_vm._v("Working With Our Mission")]), _vm._v(" "), _c('p', [_vm._v(" We are dedicated to promoting empowerment of people, protection of the environment, service to Humanity in health care & support and respect for cultural diversity. Our commitment lies in implementing governmental schemes with the help of\n          volunteer efforts so as to induce a significant change at the much needed grass roots levels of the society. ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-6"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": __webpack_require__("AyQr"),
      "alt": "Helping create a better society"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-6"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": __webpack_require__("LLFd"),
      "alt": "Pioneers in social service"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-6 text-tile"
  }, [_c('h5', [_vm._v("Staying Focussed With Our Vision")]), _vm._v(" "), _c('p', [_vm._v("Our organization will distinguish itself as a pioneer in rendering social welfare services. It will further be recognized for the passion of its work in providing quality, innovative care to the betterment of all the communities it will be involved\n          with.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-6 text-tile"
  }, [_c('h5', [_vm._v("Making a better society one friend at a time")]), _vm._v(" "), _c('p', [_vm._v("Formed in 2000, we are a Non-Governmental Organisation (NGO) based in Haridwar, Uttarakhand. Through our continuous involvement at the grass-root levels of the society, we have been successfully addressing the health related & socio-economic\n          needs of the deprived sections of our society. ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-6"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": __webpack_require__("SvNe"),
      "alt": "Making Friends"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-6"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": __webpack_require__("4zFl"),
      "alt": "Helping people in the slums"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-6 text-tile"
  }, [_c('h5', [_vm._v("Healthcare and medical services for the slums")]), _vm._v(" "), _c('p', [_vm._v("With 15 years of experience, we have undertaken various projects targeting core issues of the urban slums like women & child development, social welfare, health & hygiene, family planning, Ante Natal Care (ANC), Post Natal Care (PNC) &\n          child immunization. We have further partnered on targeted intervention projects with focus on HIV AIDS. ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-6 text-tile"
  }, [_c('h5', [_vm._v("Dedicated and Well Trained Teams")]), _vm._v(" "), _c('p', [_vm._v("We have experienced teams of doctors, nurses, Auxiliary Nurse Midwifery (ANM's) and General Nursing and Midwifery (GNM's). Further supporting us are Accredited Social Health Activists (ASHA's) who help in organising camps and spreading the word.\n          Together, we have changed lives by bringing awareness on different health related issues. ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-6"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": __webpack_require__("nejm"),
      "alt": "Our People"
    }
  })])]), _vm._v(" "), _c('hr')])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eiMS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/h9.8343129.jpg";

/***/ }),

/***/ "ejIc":
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ "et+u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_baguetteBox_js__ = __webpack_require__("/5fg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_baguetteBox_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_baguetteBox_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Uphc_data_js__ = __webpack_require__("WqPl");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showGallery: false,
      fileTitles: __WEBPACK_IMPORTED_MODULE_1__Uphc_data_js__["a" /* fileTitles */]
    };
  },

  methods: {
    visibleGallery: function visibleGallery() {
      this.showGallery = true;
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_0_baguetteBox_js___default.a.run('.gallery');
        console.log("baguebox running");
      }, 1500);
    },
    hideGallery: function hideGallery() {
      this.showGallery = false;
      window.scrollTo(0, 70);
    }
  }
});

/***/ }),

/***/ "fUAX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/8.9caaae5.jpg";

/***/ }),

/***/ "fXma":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleMap_vue__ = __webpack_require__("W2A4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_068fbd4e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleMap_vue__ = __webpack_require__("52BY");
function injectStyle (ssrContext) {
  __webpack_require__("HKyT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-068fbd4e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_068fbd4e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleMap_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ff2i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Awards_vue__ = __webpack_require__("1+ad");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bef8480_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Awards_vue__ = __webpack_require__("pqHt");
function injectStyle (ssrContext) {
  __webpack_require__("0axH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7bef8480"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Awards_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bef8480_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Awards_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fp+d":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/13.9449842.jpg";

/***/ }),

/***/ "gCoM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sign-4.d0ede1a.jpg";

/***/ }),

/***/ "gGNZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/13.970de5c.jpg";

/***/ }),

/***/ "gHcG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fun.c5499aa.jpg";

/***/ }),

/***/ "gaAv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/aware.5c41570.jpg";

/***/ }),

/***/ "gzmH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h9Gp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/6.ac724b5.jpg";

/***/ }),

/***/ "h9Ua":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/18.e1c97ce.jpg";

/***/ }),

/***/ "hA7s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container card-deck-div"
  }, [_c('h1', [_vm._v("Latest Events")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card-deck row"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('img', {
    staticClass: "card-img-top",
    attrs: {
      "src": __webpack_require__("m8T5"),
      "alt": "Card image cap"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('router-link', {
    staticClass: "btn btn-warning btn-block btn-large",
    attrs: {
      "tag": "button",
      "to": {
        path: '/events'
      },
      "exact": ""
    }
  }, [_vm._v("Show More")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('img', {
    staticClass: "card-img-top",
    attrs: {
      "src": __webpack_require__("V7lH"),
      "alt": "Card image cap"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('router-link', {
    staticClass: "btn btn-warning btn-block btn-large",
    attrs: {
      "tag": "button",
      "to": {
        path: '/events#mas'
      },
      "exact": ""
    }
  }, [_vm._v("Show More")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('img', {
    staticClass: "card-img-top",
    attrs: {
      "src": __webpack_require__("S57C"),
      "alt": "Card image cap"
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('router-link', {
    staticClass: "btn btn-warning btn-block",
    attrs: {
      "tag": "button",
      "to": {
        path: '/events#wad'
      },
      "exact": ""
    }
  }, [_vm._v("Show More")])], 1)])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Clean India Mission")]), _vm._v(" "), _c('p', {
    staticClass: "card-text d-none d-sm-block"
  }, [_vm._v("We went above and beyond to fully support the Swachh Bharat Abhiyan introduced by PM Modi.")]), _vm._v(" "), _c('p', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Organised on 23 Feb 2017.")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Mahila Aarogya Samiti")]), _vm._v(" "), _c('p', {
    staticClass: "card-text d-none d-sm-block"
  }, [_vm._v(" A group of local women who focus on helping other women in their respective local areas to raise issues faced in the under-privileged sections of the society.")]), _vm._v(" "), _c('p', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("An ongoing campaign.")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("World AIDS Day")]), _vm._v(" "), _c('p', {
    staticClass: "card-text d-none d-sm-block"
  }, [_vm._v("We organised this event to provide books and food to the children living in the slums near Birla Ghat (Haridwar) while spreading awareness about AIDS with the locals.")]), _vm._v(" "), _c('p', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Carried out on 1 December 2013.")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hLro":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3.793d323.jpg";

/***/ }),

/***/ "hO7p":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/15.ce2bedb.jpg";

/***/ }),

/***/ "hYMR":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./1.jpg": "vHbR",
	"./10.jpg": "jU7d",
	"./11.jpg": "jkXi",
	"./12.jpg": "jQwH",
	"./13.jpg": "fp+d",
	"./14.jpg": "FCaU",
	"./15.jpg": "VUxD",
	"./2.jpg": "aeb7",
	"./3.jpg": "Bwa8",
	"./4.jpg": "ryXO",
	"./5.jpg": "FYEm",
	"./6.jpg": "FRxS",
	"./7.jpg": "G6XM",
	"./8.jpg": "jBSe",
	"./9.jpg": "3o0v"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "hYMR";

/***/ }),

/***/ "hc9F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hfX/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ti-3.9211e8e.jpg";

/***/ }),

/***/ "hwtx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_baguetteBox_js__ = __webpack_require__("/5fg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_baguetteBox_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_baguetteBox_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Kishore_data_js__ = __webpack_require__("DLYX");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showGallery: false,
      fileTitles: __WEBPACK_IMPORTED_MODULE_1__Kishore_data_js__["a" /* fileTitles */]
    };
  },

  methods: {
    visibleGallery: function visibleGallery() {
      this.showGallery = true;
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_0_baguetteBox_js___default.a.run('.gallery');
        console.log("baguebox running");
      }, 1000);
    },
    hideGallery: function hideGallery() {
      this.showGallery = false;
      window.scrollTo(0, 900);
    }
  }
});

/***/ }),

/***/ "iLVK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeInRight",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "container",
    attrs: {
      "enter-active-area": "animated fadeIn"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h1', {
    staticClass: "text-center about-us-heading"
  }, [_vm._v("Reports")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://drive.google.com/open?id=0Bx8HCAUydkPkOEk2YlA2RDdQLU0"
    }
  }, [_vm._v("Click Here for our Annual Report 2013-2014")])])]), _vm._v(" "), _c('hr')])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "idvo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeInRight",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "container projects-div"
  }, [_c('div', {
    key: "1",
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Our Projects")])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('Uphc'), _vm._v(" "), _c('Hridya'), _vm._v(" "), _c('Ti'), _vm._v(" "), _c('Telecounselling')], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jBSe":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/8.46cce48.jpg";

/***/ }),

/***/ "jDLz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mas_vue__ = __webpack_require__("woL0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e45549a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Mas_vue__ = __webpack_require__("zrjW");
function injectStyle (ssrContext) {
  __webpack_require__("nGU0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e45549a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e45549a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Mas_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jJwh":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kid-group.46a4b70.jpg";

/***/ }),

/***/ "jQwH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/12.5f67e9f.jpg";

/***/ }),

/***/ "jU7d":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/10.418839e.jpg";

/***/ }),

/***/ "jkXi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/11.5cce792.jpg";

/***/ }),

/***/ "jtZU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/10.d7ac677.jpg";

/***/ }),

/***/ "jwj7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card text-center col-sm-12"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Telecounselling Project")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(" Also know as 'Hridaya Project' is aimed at reducing transmission of HIV/AIDS among Injecting Drug Users (IDU's) through awareness campaings and medical support. It is implemented by the India HIV/AIDS Alliance. This project was implemented under\n        FCRA category from 2012 - 2016.\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning showGallery",
    on: {
      "click": _vm.visibleGallery
    }
  }, [_vm._v("Show Gallery")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated slideInUp",
      "leave-active-class": "animated fadeOutDown",
      "appear": ""
    }
  }, [(_vm.showGallery) ? _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "id": "second-btn"
    },
    on: {
      "click": _vm.hideGallery
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Gallery is coming soon!")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "id": "second-btn"
    },
    on: {
      "click": _vm.hideGallery
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e()])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kEjl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.2be6490.jpg";

/***/ }),

/***/ "kK0n":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bp-check-2.2e91ef5.jpg";

/***/ }),

/***/ "kVHO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.81cc786.jpg";

/***/ }),

/***/ "kX+5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card text-center col-sm-12"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Community Action on Harm Reduction Project (CAHR)")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(" Known as 'Hridaya Project', it was aimed at reducing transmission of HIV/AIDS among Injecting Drug Users (IDU's) as well as raising their concerns with the local bodies. It was implemented under FCRA funding from 2012 - 2016.\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning showGallery",
    on: {
      "click": _vm.visibleGallery
    }
  }, [_vm._v("Show Gallery")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated slideInUp",
      "leave-active-class": "animated fadeOutDown",
      "appear": ""
    }
  }, [(_vm.showGallery) ? _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "id": "second-btn"
    },
    on: {
      "click": _vm.hideGallery
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row gallery"
  }, [_vm._l((_vm.fileTitles), function(file) {
    return _c('div', {
      staticClass: "col-md-4 col-sm-6"
    }, [_c('a', {
      staticClass: "lightbox",
      attrs: {
        "href": __webpack_require__("JeQr")("./" + (file.name))
      }
    }, [_c('img', {
      staticClass: "img-responsive rounded",
      attrs: {
        "src": __webpack_require__("JeQr")("./" + (file.name)),
        "alt": file.alt
      }
    })])])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "id": "second-btn"
    },
    on: {
      "click": _vm.hideGallery
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 2)]) : _vm._e()])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kZlj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ti-16.f53bf83.jpg";

/***/ }),

/***/ "kzuw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kids-more.5aa6fa0.jpg";

/***/ }),

/***/ "l7ro":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/posing.083b069.jpg";

/***/ }),

/***/ "l84l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Uphc_vue__ = __webpack_require__("et+u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ca9b550_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Uphc_vue__ = __webpack_require__("qBuk");
function injectStyle (ssrContext) {
  __webpack_require__("Tnwi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ca9b550"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Uphc_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ca9b550_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Uphc_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lFVH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/19.34e501a.jpg";

/***/ }),

/***/ "lojV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/h1.b6f68e4.jpg";

/***/ }),

/***/ "ltwe":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/h11.e3d9526.jpg";

/***/ }),

/***/ "luVP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/12.491f702.jpg";

/***/ }),

/***/ "m+ok":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "m8T5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bright.6508a4e.jpg";

/***/ }),

/***/ "mOGj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/14.88119de.jpg";

/***/ }),

/***/ "mfZc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sign.c3309ce.jpg";

/***/ }),

/***/ "nGU0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nejm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/our-team.1a62ee5.jpg";

/***/ }),

/***/ "ni7q":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/6.0586e8b.jpg";

/***/ }),

/***/ "npb6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/single-girl.3e002c3.jpg";

/***/ }),

/***/ "ntQ8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "o+p8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/advising.7da6d16.jpg";

/***/ }),

/***/ "oJ8t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "owuG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/room.5ddd3e2.jpg";

/***/ }),

/***/ "pFFJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cry.32ddde4.jpg";

/***/ }),

/***/ "pflM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/training-4.e541ebd.jpg";

/***/ }),

/***/ "pj53":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/h4.00fbe1e.jpg";

/***/ }),

/***/ "pqHt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container awards-div"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Our Achievements")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "media col-sm-11 mx-auto"
  }, [_c('img', {
    staticClass: "d-flex mr-3 img-fluid align-self-center",
    attrs: {
      "src": __webpack_require__("vXj8"),
      "alt": "Generic placeholder image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h5', {
    staticClass: "mt-0"
  }, [_vm._v("Helped Children & Families Stay Healthy")]), _vm._v(" Implemented Urban Reproductive & Child Health Program (RCH) under Uttarakhand Health and Family Welfare Society. Funded by National Health Mission (NHM) as an initiative by Government of India, in this project we focussed on the health needs\n        of urban poor slum population and targeted reproductive and child health, children immunisation, family welfare, family planning needs, OPD, basic lab testings and free dispensing of medicines.\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "media col-sm-11 mx-auto"
  }, [_c('img', {
    staticClass: "d-flex mr-3 img-fluid align-self-center",
    attrs: {
      "src": __webpack_require__("6LVP"),
      "alt": "Generic placeholder image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h5', {
    staticClass: "mt-0"
  }, [_vm._v("Saved Lives With AIDS Intervention")]), _vm._v(" Implemented targeted intervention programs under the Uttarakhand State AIDS Control Society (USACS) funded by NACO on the core components like Female Sex Workers (FSW's), Injected Drug Users (IDU's), street children, truckers for more than 10\n        years. As a result, we signicantly prevented and contained AIDS transmission in the high risk groups in areas of Haridwar city.\n      ")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qBuk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card text-center col-sm-12"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Urban Primary Health Centers (UPSC's)")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("Launched under the National Urban Health Mission (NUHM), this project provides healthcare and medical services to the urban slum population. We have been running it since August 2010 in the Roorkee Area.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning btn-md showGallery",
    on: {
      "click": _vm.visibleGallery
    }
  }, [_vm._v("Show Gallery")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated slideInUp",
      "leave-active-class": "animated fadeOutDown",
      "appear": ""
    }
  }, [(_vm.showGallery) ? _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "id": "first-close-btn"
    },
    on: {
      "click": _vm.hideGallery
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row gallery"
  }, [_vm._l((_vm.fileTitles), function(file) {
    return _c('div', {
      key: file.name,
      staticClass: "col-md-4 col-sm-6"
    }, [_c('a', {
      staticClass: "lightbox",
      attrs: {
        "href": __webpack_require__("YJwR")("./" + (file.name))
      }
    }, [_c('img', {
      staticClass: "img-responsive rounded",
      attrs: {
        "src": __webpack_require__("YJwR")("./" + (file.name)),
        "alt": file.alt
      }
    })])])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "id": "second-btn"
    },
    on: {
      "click": _vm.hideGallery
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 2)]) : _vm._e()])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qL50":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/staff-kids.2184df0.jpg";

/***/ }),

/***/ "qQa3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Asha_vue__ = __webpack_require__("59bj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c486d0d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Asha_vue__ = __webpack_require__("MDv7");
function injectStyle (ssrContext) {
  __webpack_require__("I6H7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c486d0d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Asha_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c486d0d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Asha_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qQoC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Telecounselling_vue__ = __webpack_require__("Ric7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1744b154_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Telecounselling_vue__ = __webpack_require__("jwj7");
function injectStyle (ssrContext) {
  __webpack_require__("oJ8t")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1744b154"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Telecounselling_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1744b154_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Telecounselling_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qk7d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qpAe":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0.2f7defc.jpg";

/***/ }),

/***/ "rHlQ":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./1.jpg": "7roi",
	"./12.jpg": "c7Dw",
	"./13.jpg": "gGNZ",
	"./16.jpg": "Iirp",
	"./18.jpg": "h9Ua",
	"./3.jpg": "hLro",
	"./4.jpg": "WZ4d",
	"./Ti-1.jpg": "1/pI",
	"./Ti-10.jpg": "SdWy",
	"./Ti-11.jpg": "87iU",
	"./Ti-12.jpg": "S4Jt",
	"./Ti-16.jpg": "kZlj",
	"./Ti-17.jpg": "rLUs",
	"./Ti-19.jpg": "zWEX",
	"./Ti-2.jpg": "cthV",
	"./Ti-3.jpg": "hfX/",
	"./Ti-4.jpg": "TEpQ",
	"./Ti-5.jpg": "tf5B",
	"./Ti-6.jpg": "HILi",
	"./Ti-7.jpg": "t7dq",
	"./Ti-8.jpg": "Shms",
	"./Ti-9.jpg": "uSa6"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "rHlQ";

/***/ }),

/***/ "rLUs":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ti-17.2fb6098.jpg";

/***/ }),

/***/ "rab3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/training-12.e944df5.jpg";

/***/ }),

/***/ "rxOq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/h10.cc030eb.jpg";

/***/ }),

/***/ "ryXO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4.8d9cdf2.jpg";

/***/ }),

/***/ "sFe7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kid-inject.4f0e6a2.jpg";

/***/ }),

/***/ "sXV+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/training-8.cb7b939.jpg";

/***/ }),

/***/ "srEc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/10.bd7e86f.jpg";

/***/ }),

/***/ "syno":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/old-doc.aa5d48d.jpg";

/***/ }),

/***/ "szMG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Carousel_vue__ = __webpack_require__("xs8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LatestEvents_vue__ = __webpack_require__("v2ET");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CurrentCampaign_vue__ = __webpack_require__("EGie");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Awards_vue__ = __webpack_require__("ff2i");
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    "my-carousel": __WEBPACK_IMPORTED_MODULE_0__Carousel_vue__["a" /* default */],
    "my-latestevents": __WEBPACK_IMPORTED_MODULE_1__LatestEvents_vue__["a" /* default */],
    "my-current-campaign": __WEBPACK_IMPORTED_MODULE_2__CurrentCampaign_vue__["a" /* default */],
    "my-awards": __WEBPACK_IMPORTED_MODULE_3__Awards_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "t7dq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ti-7.95d556a.jpg";

/***/ }),

/***/ "tOtp":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./1.jpg": "kEjl",
	"./10.jpg": "jtZU",
	"./11.jpg": "LQsL",
	"./12.jpg": "luVP",
	"./13.jpg": "889b",
	"./14.jpg": "mOGj",
	"./15.jpg": "4uSL",
	"./16.jpg": "KIuW",
	"./17.jpg": "S3oR",
	"./18.jpg": "TaK+",
	"./19.jpg": "lFVH",
	"./2.jpg": "kVHO",
	"./20.jpg": "PvAO",
	"./3.jpg": "0kPo",
	"./6.jpg": "ni7q",
	"./7.jpg": "TbFu",
	"./8.jpg": "fUAX",
	"./9.jpg": "SQJG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tOtp";

/***/ }),

/***/ "tUis":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sign-2.04d0d69.jpg";

/***/ }),

/***/ "teIl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("HCTz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66401c43_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("O4y2");
function injectStyle (ssrContext) {
  __webpack_require__("zZx9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66401c43"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66401c43_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tf5B":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ti-5.46ee203.jpg";

/***/ }),

/***/ "tlJR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/rahul-2.d98e006.jpg";

/***/ }),

/***/ "u9fR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/happy-doc.90f1663.jpg";

/***/ }),

/***/ "uSa6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ti-9.047422b.jpg";

/***/ }),

/***/ "ufs2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/patient-line.aeae631.jpg";

/***/ }),

/***/ "ulPN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ranjana.7bee1c4.jpg";

/***/ }),

/***/ "upEf":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./award-lady.jpg": "Nh0a",
	"./book-kid.jpg": "aW8E",
	"./food-2.jpg": "Rb0y",
	"./food.jpg": "SWvm",
	"./house.jpg": "CnMM",
	"./kid-dad.jpg": "YCJZ",
	"./kid-group.jpg": "jJwh",
	"./kids-books.jpg": "S57C",
	"./kids-group.jpg": "TNr5",
	"./kids-many.jpg": "EsH0",
	"./kids-more.jpg": "kzuw",
	"./kids-poor.jpg": "Vovp",
	"./kids-sit.jpg": "cWu0",
	"./kids.jpg": "WO7R",
	"./lady-happy.jpg": "Qs9i",
	"./parents-kids.jpg": "wmIG",
	"./partap-2.jpg": "AgHz",
	"./partap.jpg": "NFTS",
	"./path.jpg": "Wefo",
	"./posing.jpg": "l7ro",
	"./preaching-2.jpg": "MIpg",
	"./preaching.jpg": "/SD8",
	"./sign.jpg": "zfun",
	"./staff-kids.jpg": "O9HZ",
	"./study.jpg": "bnlo"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "upEf";

/***/ }),

/***/ "v2ET":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LatestEvents_vue__ = __webpack_require__("FuDk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6954350a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_LatestEvents_vue__ = __webpack_require__("hA7s");
function injectStyle (ssrContext) {
  __webpack_require__("3Zj4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6954350a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LatestEvents_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6954350a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_LatestEvents_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vHbR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.02366be.jpg";

/***/ }),

/***/ "vNx4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-closeup.17c0348.jpg";

/***/ }),

/***/ "vXj8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/awards-1.cd02e30.jpg";

/***/ }),

/***/ "vss5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/asha-aware-2.b815a27.jpg";

/***/ }),

/***/ "w5N9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sign.94c5da0.jpg";

/***/ }),

/***/ "wS09":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fileTitles; });
var fileTitles = [{
  name: '1.jpg',
  alt: "sign"
}, {
  name: '2.jpg',
  alt: "more signage"
}, {
  name: '3.jpg',
  alt: "sharing wisdom"
}, {
  name: '4.jpg',
  alt: 'initiating'
}, {
  name: '5.jpg',
  alt: 'sharing ideas'
}, {
  name: '6.jpg',
  alt: 'Talking about nutrition'
}, {
  name: '7.jpg',
  alt: 'ASHAs havin fun'
}, {
  name: '8.jpg',
  alt: 'Light lecture'
}, {
  name: "9.jpg",
  alt: 'ASHAs listening'
}, {
  name: '10.jpg',
  alt: 'practicising more knowledge'
}, {
  name: "11.jpg",
  alt: 'ASHAs grasping knowledge about their issues'
}, {
  name: '12.jpg',
  alt: 'About health'
}, {
  name: '13.jpg',
  alt: 'More Lectures'
}, {
  name: '14.jpg',
  alt: 'Intense focus'
}, {
  name: '15.jpg',
  alt: 'Learning a lot'
}];

/***/ }),

/***/ "wfmi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fileTitles; });
var fileTitles = [{
  name: '0.jpg',
  alt: "Our Sign"
}, {
  name: '16.jpg',
  alt: "Team member Helping"
}, {
  name: '2.jpg',
  alt: "Kids Study"
}, {
  name: '3.jpg',
  alt: 'Giving out food'
}, {
  name: '4.jpg',
  alt: 'More food spread'
}, {
  name: '5.jpg',
  alt: 'Typical house in slums'
}, {
  name: '6.jpg',
  alt: 'Parents with kids'
}, {
  name: '7.jpg',
  alt: 'kids huddled up'
}, {
  name: "8.jpg",
  alt: 'kids with books'
}, {
  name: '9.jpg',
  alt: 'kids in a group'
}, {
  name: "10.jpg",
  alt: 'more kids in a group'
}, {
  name: '11.jpg',
  alt: 'Poor kids'
}, {
  name: '12.jpg',
  alt: 'Kids sitting and drawing'
}, {
  name: '13.jpg',
  alt: "Kids in Slums"
}, {
  name: '14.jpg',
  alt: "Slum lady volunteer"
}, {
  name: '15.jpg',
  alt: "Parents and their kids"
}, {
  name: '1.jpg',
  alt: "Our staff with kids"
}, {
  name: '17.jpg',
  alt: 'mum looked after'
}];

/***/ }),

/***/ "wmIG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/parents-kids.20f1618.jpg";

/***/ }),

/***/ "woL0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_baguetteBox_js__ = __webpack_require__("/5fg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_baguetteBox_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_baguetteBox_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Mas_data_js__ = __webpack_require__("4rJJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showGallery: false,
      fileTitles: __WEBPACK_IMPORTED_MODULE_1__Mas_data_js__["a" /* fileTitles */]
    };
  },

  methods: {
    visibleGallery: function visibleGallery() {
      this.showGallery = true;
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_0_baguetteBox_js___default.a.run('.gallery');
      }, 1000);
    },
    hideGallery: function hideGallery() {
      this.showGallery = false;
      window.scrollTo(0, 400);
    }
  }
});

/***/ }),

/***/ "wqTG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("szMG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_474b18e9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("BkFL");
function injectStyle (ssrContext) {
  __webpack_require__("YeJh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-474b18e9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_474b18e9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x74d":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3.50af4d2.jpg";

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header_vue__ = __webpack_require__("teIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer_vue__ = __webpack_require__("TVmP");
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    "app-header": __WEBPACK_IMPORTED_MODULE_0__components_Header_vue__["a" /* default */],
    "app-footer": __WEBPACK_IMPORTED_MODULE_1__components_Footer_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "xg8S":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/baby-weigh.5b17f81.jpg";

/***/ }),

/***/ "xi1y":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/training-2.a44195b.jpg";

/***/ }),

/***/ "xpWa":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shivir-2.41e0c01.jpg";

/***/ }),

/***/ "xr0W":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/many-in.8b104d5.jpg";

/***/ }),

/***/ "xs8L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Carousel_vue__ = __webpack_require__("Cnv6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63e093ea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Carousel_vue__ = __webpack_require__("Oc/I");
function injectStyle (ssrContext) {
  __webpack_require__("hc9F")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-63e093ea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Carousel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63e093ea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Carousel_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xskE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndraDhanush_vue__ = __webpack_require__("afiw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70ea804f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_IndraDhanush_vue__ = __webpack_require__("9IM7");
function injectStyle (ssrContext) {
  __webpack_require__("Oqb/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-70ea804f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndraDhanush_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70ea804f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_IndraDhanush_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ym+s":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/incubators.8652e6a.jpg";

/***/ }),

/***/ "zNKM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mi-cover.8a496e9.jpg";

/***/ }),

/***/ "zNct":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/group-bricks.af57396.jpg";

/***/ }),

/***/ "zWEX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ti-19.417073e.jpg";

/***/ }),

/***/ "zZx9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zfun":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sign.79a4cc7.jpg";

/***/ }),

/***/ "zqbm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeInRight",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('my-map'), _vm._v(" "), _c('div', {
    staticClass: "row location-text",
    attrs: {
      "id": "our-centers"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Our Locations")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeInRight",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "card bg-light mb-3"
  }, [_c('div', {
    staticClass: "card-header bg-warning"
  }, [_vm._v("Registered Office")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Haridwar Main Office")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("Address:")]), _vm._v(" 344 MIG, Vivek Vihar Colony, Ranipur More, Haridwar")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("Phone:")]), _vm._v(" +91 9412073651")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("Email:")]), _vm._v(" friendshwr@gmail.com")])])])])]), _vm._v(" "), _vm._l((_vm.centersArr), function(center) {
    return _c('div', {
      staticClass: "col-sm-6"
    }, [_c('transition', {
      attrs: {
        "enter-active-class": "animated fadeInRight",
        "appear": ""
      }
    }, [_c('div', {
      staticClass: "card bg-light mb-3"
    }, [_c('div', {
      staticClass: "card-header bg-warning"
    }, [_vm._v("Urban Primary Health Center")]), _vm._v(" "), _c('div', {
      staticClass: "card-body"
    }, [_c('h4', {
      staticClass: "card-title"
    }, [_vm._v(_vm._s(center.centerName))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("Address:")]), _vm._v(" " + _vm._s(center.address))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("Phone:")]), _vm._v(" +91 9412073651")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("Email:")]), _vm._v(" friendshwr@gmail.com")])])])])], 1)
  })], 2)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zqmC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Projects_vue__ = __webpack_require__("P0G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cc6dd49_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Projects_vue__ = __webpack_require__("idvo");
function injectStyle (ssrContext) {
  __webpack_require__("XrJi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5cc6dd49"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Projects_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cc6dd49_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Projects_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zrjW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card text-center col-sm-12"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Mahila Aarogya Samiti (Women Health Society)")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("A society consisting of 8-12 local women per community, who raise awareness on issues relating to health, nutrition, water and sanitation for women living in the slums. They then share their findings and feedback with us, so we can act swiftly in\n        resolving their issues.\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning btn-md showGallery",
    on: {
      "click": _vm.visibleGallery
    }
  }, [_vm._v("Show Gallery")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated slideInUp",
      "leave-active-class": "animated fadeOutDown",
      "appear": ""
    }
  }, [(_vm.showGallery) ? _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "id": "first-close-btn"
    },
    on: {
      "click": _vm.hideGallery
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row gallery"
  }, [_vm._l((_vm.fileTitles), function(file) {
    return _c('div', {
      key: file.name,
      staticClass: "col-md-4 col-sm-6"
    }, [_c('a', {
      staticClass: "lightbox",
      attrs: {
        "href": __webpack_require__("tOtp")("./" + (file.name))
      }
    }, [_c('img', {
      staticClass: "img-responsive rounded",
      attrs: {
        "src": __webpack_require__("tOtp")("./" + (file.name)),
        "alt": file.alt
      }
    })])])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "id": "second-btn"
    },
    on: {
      "click": _vm.hideGallery
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 2)]) : _vm._e()])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.c973ccd763c366b32138.js